import { z } from 'zod';
import { PromotionCreditType } from '../../constants/promotion-credit-type.js';
import { optionalUuidString, requiredEnumIdString, requiredUuidString, } from '../zod-helpers/index.js';
import { PROMOTION_CREDIT_CONSTRAINTS } from './constraints.js';
import { creditAmountInput } from './credit-amount-input.js';
import { dateStringInput } from './date-string-input.js';
import { promotionCreditLineFormSchema } from './line-form.js';
import { promotionCreditLinesMessage } from './lines-message.js';
import { lowercaseUuid } from './lowercase-uuid.js';
import { numberStringInput } from './number-string-input.js';
import { OVERPAYMENT_NOT_ISSUABLE_MESSAGE } from './overpayment-not-issuable-message.js';
import { refineCreditForm } from './refine-credit-form.js';
const { details, notes, lines, amount } = PROMOTION_CREDIT_CONSTRAINTS;
const lengthMessage = (label, maxLength) => `${label} must be ${maxLength} characters or less.`;
// The issue dialog fills the dates and amount from its defaults, so blank dates pass and the API applies the brand's lifetime.
export const issuePromotionCreditFormSchema = z
    .object({
    customerId: requiredUuidString('Customer is required.', 'Invalid customer selection.').transform(lowercaseUuid),
    brandId: requiredUuidString('Brand is required.', 'Invalid brand selection.').transform(lowercaseUuid),
    promotionCreditTypeId: requiredEnumIdString(PromotionCreditType, 'Credit type is required.', 'Invalid credit type selection.').refine((value) => value !== String(PromotionCreditType.OVERPAYMENT), {
        message: OVERPAYMENT_NOT_ISSUABLE_MESSAGE,
    }),
    amount: numberStringInput(creditAmountInput, amount.label),
    dateApplicable: dateStringInput('Issued date'),
    expirationDate: dateStringInput('Expiration date'),
    details: z
        .string()
        .trim()
        .max(details.maxLength, lengthMessage(details.label, details.maxLength)),
    notes: z.string().trim().max(notes.maxLength, lengthMessage(notes.label, notes.maxLength)),
    promotionId: optionalUuidString('Invalid promotion selection.').transform(lowercaseUuid),
    lines: z.array(promotionCreditLineFormSchema).max(lines.max, promotionCreditLinesMessage),
})
    .superRefine(refineCreditForm);
//# sourceMappingURL=issue-form.js.map